// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__3lJOA","container":"style_container__sjaCt","frame":"style_frame__RsSTV","content":"style_content__ty5lB"};